export default __webpack_public_path__ + "static/media/back.7a9080a3.svg";